import splitInputString from 'utils/splitInputString';

export function getPopupWindowParam(config, param) {
	// split the config into an array of the parameters
	const paramArray = config?.length ? splitInputString(config) : [];
	// find this parameter
	const thisParam = paramArray.find(string => string.indexOf(param) >= 0);
	// get the number that comes after {param}=
	const result = thisParam
		? thisParam.trim().substring(param.length + 1)
		: '';
	return result;
}

export function setPopupWindowParam(oldConfig, param, newValue) {
	// sanitise the incoming data and define the new string to be entered into the config
	const newValueString =
		typeof newValue === 'number' ? newValue.toString() : newValue;
	const isNewValueEmpty = !newValue;
	const newParam = isNewValueEmpty ? '' : `${param}=${newValueString}`;

	// split the existing config string into parameters
	const paramArray = oldConfig?.length ? splitInputString(oldConfig) : [];

	// find the input parameter and CRUD accordingly
	const paramIndex = paramArray.findIndex(
		string => string.indexOf(param) >= 0
	);
	if (paramIndex === -1) {
		if (!isNewValueEmpty) {
			paramArray.push(newParam);
		}
	} else {
		if (isNewValueEmpty) {
			paramArray.splice(paramIndex, 1);
		} else {
			paramArray[paramIndex] = newParam;
		}
	}

	// rebuild the config string
	const newConfig = paramArray.length ? paramArray.join() : '';

	return newConfig;
}
